/* eslint-disable import/named */

import { DenizAraciParametreleriResultType } from 'src/types/services/hymotsc/deniz-araci-parametreleri.type';
import { EmirResultType, EmirGruplariResultType, CommandResultsType } from 'src/types/services/hymotsc/emir.type';
import { EtmenSiniflariResultType } from 'src/types/services/hymotsc/etmen-siniflari.type';
import { EtmenTurleriResultType } from 'src/types/services/hymotsc/etmen-turleri.type';
import { EtmenResultType } from 'src/types/services/hymotsc/etmen.type';
import { HavaAraciParametreleriResultType } from 'src/types/services/hymotsc/hava-araci-parametreleri.type';
import { IkmalSiniflariResultType } from 'src/types/services/hymotsc/ikmal-siniflari.type';
import { InsanYapimiEngelTuruResultType } from 'src/types/services/hymotsc/insan-yapimi-engel-turu.type';
import { MuhabereCihaziTuruResultType } from 'src/types/services/hymotsc/muhabere-cihazi-turu.type';
import { MuhimmatIndekslerResultType } from 'src/types/services/hymotsc/muhimmat-indeksler.type';
import { MuhimmatTurleriResultType } from 'src/types/services/hymotsc/muhimmat-turleri.type';
import { TaraflarResultType } from 'src/types/services/hymotsc/taraflar.type';
import { TmkKalemiOzellikleriResultType } from 'src/types/services/hymotsc/tmk-kalemi-ozellikleri.type';
import {
  SET_HAVA_2D_DATA,
  TERRAIN_TYPES_ADDED,
  TERRAIN_TYPES_POPULATED,
  BORDER_TYPES_SET,
  HEIGHT_CATEGORIES_SET,
  QUADS_SET,
  SIDES_POPULATED,
  SIDE_RELATIONS_POPULATED,
  FACTIONS_POPULATED,
  PROTOTYPES_POPULATED,
  PROTOTYPES_REMOVED,
  SYSTEMS_POPULATED,
  AMMO_INDEXES_POPULATED,
  SUPPLIES_POPULATED,
  AMMUNITIONS_POPULATED,
  AIRCRAFTS_POPULATED,
  NAVALCRAFTS_POPULATED,
  OBSTACLES_POPULATED,
  COMM_DEVICES_POPULATED,
  AGENTS_POPULATED,
  SET_COMMANDS,
  SET_COMMAND_GROUPS,
  ADD_COMMAND,
  EDIT_COMMAND,
  DELETE_COMMANDS,
  SET_EDITED_COMMANDS,
  DELETED_COMMANS_IN_EDITED_COMMANDS,
  RESET_DELETED_COMMANDS_IN_EDITED_COMMANDS,
  SET_COMAOS,
  DELETE_COMAO,
  ADD_COMAO,
  EDIT_COMAO,
  SET_SELECTED_ETMEN,
  DELETE_NODES,
  ADD_NODE,
  DELETE_FILTERED_SYSTEMS,
  ADD_COMMAND_RESULT,
  SET_ACTIVE_SIDES,
} from '../../redux-types';
import { DugumResultType } from 'src/types/services/hymotsc/dugum.type';
import { MapUnit, UnitSide } from 'src/types/unit.type';

// export const setHava2dData = (payload: Hava2DDBData) => {
//   return {
//     type: SET_HAVA_2D_DATA,
//     payload,
//   };
// };

// export const addTerrainType = (payload: AraziTuruResultType) => {
//   return {
//     type: TERRAIN_TYPES_ADDED,
//     payload,
//   };
// };

// export const setTerrainTypes = (payload: AraziTuruResultType[]) => {
//   return {
//     type: TERRAIN_TYPES_POPULATED,
//     payload,
//   };
// };

// export const setBorderTypes = (payload: EngelOzellikleriResultType[]) => {
//   return {
//     type: BORDER_TYPES_SET,
//     payload,
//   };
// };

// export const setHeightCategories = (payload: DerinlikYukseklikResultType[]) => {
//   return {
//     type: HEIGHT_CATEGORIES_SET,
//     payload,
//   };
// };

// export const setQuads = (payload: QuadResultType[]) => {
//   return {
//     type: QUADS_SET,
//     payload,
//   };
// };

export const setSides = (payload: TaraflarResultType[]) => {
  return {
    type: SIDES_POPULATED,
    payload,
  };
};

export const setActiveSides = (payload: UnitSide[]) => {
  return {
    type: SET_ACTIVE_SIDES,
    payload,
  };
};

// export const setSideRelations = (payload: TaraflarArasiIliskiResultType[]) => {
//   return {
//     type: SIDE_RELATIONS_POPULATED,
//     payload,
//   };
// };

export const setFactions = (payload: EtmenSiniflariResultType[]) => {
  return {
    type: FACTIONS_POPULATED,
    payload,
  };
};

export const setPrototypes = (payload: EtmenTurleriResultType[]) => {
  return {
    type: PROTOTYPES_POPULATED,
    payload,
  };
};

export const removePrototypes = (payload: number[]) => {
  return {
    type: PROTOTYPES_REMOVED,
    payload,
  };
};

export const setSystems = (payload: TmkKalemiOzellikleriResultType[]) => {
  return {
    type: SYSTEMS_POPULATED,
    payload,
  };
};

export const setAmmoIndexes = (payload: MuhimmatIndekslerResultType[]) => {
  return {
    type: AMMO_INDEXES_POPULATED,
    payload,
  };
};

export const setSupplies = (payload: IkmalSiniflariResultType[]) => {
  return {
    type: SUPPLIES_POPULATED,
    payload,
  };
};

export const setAmmunitions = (payload: MuhimmatTurleriResultType[]) => {
  return {
    type: AMMUNITIONS_POPULATED,
    payload,
  };
};

export const setAircrafts = (payload: HavaAraciParametreleriResultType[]) => {
  return {
    type: AIRCRAFTS_POPULATED,
    payload,
  };
};

export const setNavalcrafts = (payload: DenizAraciParametreleriResultType[]) => {
  return {
    type: NAVALCRAFTS_POPULATED,
    payload,
  };
};

export const setObstacles = (payload: InsanYapimiEngelTuruResultType[]) => {
  return {
    type: OBSTACLES_POPULATED,
    payload,
  };
};

export const setCommDevices = (payload: MuhabereCihaziTuruResultType[]) => {
  return {
    type: COMM_DEVICES_POPULATED,
    payload,
  };
};

export const setAgents = (payload: EtmenResultType[]) => {
  return {
    type: AGENTS_POPULATED,
    payload,
  };
};

export const setCommands = (payload: EmirResultType[]) => {
  return {
    type: SET_COMMANDS,
    payload,
  };
};

export const setCommandGroups = (payload: EmirGruplariResultType[]) => {
  return {
    type: SET_COMMAND_GROUPS,
    payload,
  };
};

export const addCommandResult = (payload: CommandResultsType) => {
  return {
    type: ADD_COMMAND_RESULT,
    payload,
  };
};

export const addCommand = (payload: EmirResultType) => {
  return {
    type: ADD_COMMAND,
    payload,
  };
};
export const editCommand = (payload: EmirResultType) => {
  return {
    type: EDIT_COMMAND,
    payload,
  };
};

export const setEditedCommands = (payload: { unitId: number; commands: EmirResultType[] }) => {
  return {
    type: SET_EDITED_COMMANDS,
    payload,
  };
};

export const deleteEditedCommand = (payload: { unitId: number; commandId: number }) => {
  return {
    type: DELETED_COMMANS_IN_EDITED_COMMANDS,
    payload,
  };
};

export const resetDeletedEditedCommands = () => {
  return {
    type: RESET_DELETED_COMMANDS_IN_EDITED_COMMANDS,
  };
};

export const setOverlappedEtmenId = (selectedEtmen: number | undefined) => {
  return {
    type: SET_SELECTED_ETMEN,
    payload: selectedEtmen,
  };
};

export const deleteCommands = (payload: number[]) => {
  return {
    type: DELETE_COMMANDS,
    payload,
  };
};

export const deleteNodes = (payload: number[]) => {
  return {
    type: DELETE_NODES,
    payload,
  };
};

export const addNode = (payload: DugumResultType) => {
  return {
    type: ADD_NODE,
    payload,
  };
};

// export const setComaos = (payload: TComaoGeneralType[]) => {
//   return {
//     type: SET_COMAOS,
//     payload,
//   };
// };

// export const deleteComao = (payload: number) => {
//   return {
//     type: DELETE_COMAO,
//     payload,
//   };
// };

// export const addComao = (payload: TComaoGeneralType) => {
//   return {
//     type: ADD_COMAO,
//     payload,
//   };
// };

// export const editComao = (payload: TComaoGeneralType) => {
//   return {
//     type: EDIT_COMAO,
//     payload,
//   };
// };

export const deleteFilteredSystems = (payload: { unitId: number; tmk: TmkKalemiOzellikleriResultType }) => {
  return {
    type: DELETE_FILTERED_SYSTEMS,
    payload,
  };
};
